<template>
  <div class="main-content">
    <!-- 充值规则列表页 -->
    <div v-if="showFlag">
      <el-form :inline="true" :model="searchForm" class="form-content">
        <el-row :gutter="20" class="slt" :style="{ justifyContent: 'flex-start' }">
          <el-form-item :label="$t('chongzhiguize.rechargeName')">
            <el-input v-model="searchForm.chongzhiname" :placeholder="$t('chongzhiguize.rechargeName')" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="search()">{{ $t('chongzhiguize.search') }}</el-button>
          </el-form-item>
        </el-row>

        <el-row class="ad" :style="{ justifyContent: 'flex-start' }">
          <el-form-item>
            <el-button v-if="isAuth('chongzhiguize','新增')" type="success" @click="addOrUpdateHandler()">{{ $t('chongzhiguize.add') }}</el-button>
            <el-button v-if="isAuth('chongzhiguize','删除')" type="danger" @click="deleteHandler()" :disabled="dataListSelections.length <= 0">{{ $t('chongzhiguize.delete') }}</el-button>
          </el-form-item>
        </el-row>
      </el-form>

      <div class="table-content">
        <el-table :data="dataList" border stripe style="width: 100%" v-loading="dataListLoading" @selection-change="selectionChangeHandler">
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" :label="$t('chongzhiguize.index')" width="50" align="center"></el-table-column>
          <el-table-column prop="chongzhiname" :label="$t('chongzhiguize.rechargeName')" align="center"></el-table-column>
          <el-table-column prop="minamount" :label="$t('chongzhiguize.minAmount')" align="center">
            <template slot-scope="scope">{{ scope.row.minamount }}
              <!-- {{ $t('chongzhiguize.yuan') }} -->
              THB
              </template>
          </el-table-column>
          <el-table-column prop="bonus" :label="$t('chongzhiguize.bonus')" align="center">
            <template slot-scope="scope">{{ scope.row.bonus }}
              <!-- {{ $t('chongzhiguize.yuan') }} -->
              THB
            </template>
          </el-table-column>
          <el-table-column prop="discount" :label="$t('chongzhiguize.discount')" align="center">
            <template slot-scope="scope">{{ scope.row.discount }}{{ $t('chongzhiguize.discountUnit') }}</template>
          </el-table-column>
          <el-table-column prop="chuangjiantime" :label="$t('chongzhiguize.createTime')" align="center">
            <template slot-scope="scope">{{ $options.filters.dateFormat(scope.row.chuangjiantime) }}</template>
          </el-table-column>
          <el-table-column prop="gengxintime" :label="$t('chongzhiguize.updateTime')" align="center">
            <template slot-scope="scope">{{ $options.filters.dateFormat(scope.row.gengxintime) }}</template>
          </el-table-column>
          <el-table-column :label="$t('chongzhiguize.operation')" width="200" align="center">
            <template slot-scope="scope">
              <el-button v-if="isAuth('chongzhiguize','查看')" type="success" size="mini" @click="addOrUpdateHandler(scope.row.id,'info')">{{ $t('chongzhiguize.detail') }}</el-button>
              <el-button v-if="isAuth('chongzhiguize','修改')" type="primary" size="mini" @click="addOrUpdateHandler(scope.row.id)">{{ $t('chongzhiguize.edit') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="totalPage"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination-content"
        ></el-pagination>
      </div>
    </div>
    <!-- 添加/修改页面 -->
    <add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from './add-or-update'
export default {
  components: { AddOrUpdate },
  filters: {
    dateFormat(date) {
      if (!date) return '';
      return new Date(date).toLocaleString();
    }
  },
  data() {
    return {
      searchForm: {
        chongzhiname: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      addOrUpdateFlag: false
    }
  },
  created() {
    this.getDataList();
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http({
        url: 'chongzhiguize/page',
        method: 'get',
        params: {
          page: this.pageIndex,
          limit: this.pageSize,
          chongzhiname: this.searchForm.chongzhiname
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.page.list;
          this.totalPage = data.page.totalCount;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id, type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, type);
      });
    },
    // 删除
    deleteHandler(id) {
      const ids = id ? [id] : this.dataListSelections.map(item => item.id);
      this.$confirm(`确定进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: 'chongzhiguize/delete',
          method: 'post',
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    // 搜索
    search() {
      this.pageIndex = 1;
      this.getDataList();
    }
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
}

.form-content {
  margin-bottom: 20px;
}

.table-content {
  margin-top: 20px;
}

.pagination-content {
  margin-top: 20px;
  text-align: center;
}
</style> 